import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withFieldProps } from 'hooks/useFieldProps';
import FlyupLabel from 'common/FlyupLabel';
import Spinner from 'common/Spinner';
import { withStyles } from 'theme/withStyles';
import ErrorMsg from 'common/ErrorMsg';
import Help from 'common/Help';
import Tooltip from 'common/Tooltip';

import inputStyles from './styles/input';
import rootStyles from './styles/root';

const styles = ({ forms, palette, spacing, typography }) => ({
  input: inputStyles({ forms, palette, typography }),
  root: rootStyles({ spacing }),
});

const Number = ({
  classes,
  error,
  fieldDomId,
  help,
  loading,
  name,
  onBlur,
  onChange,
  onFocus,
  onPaste,
  placeholder,
  readOnly,
  required,
  tooltip,
  type,
  validate,
  value,
}) => (
  <>
    <div className={classnames('form-group', { error, loading }, classes.root)}>
      <Spinner loading={loading} />
      <FlyupLabel
        fieldName={name}
        error={error}
        value={value}
        htmlFor={fieldDomId}
        required={required}
        tooltip={tooltip}
      />
      <input
        type={type}
        inputMode="numeric"
        className={classnames('form-control', classes.input)}
        aria-describedby={
          classnames({
            [`help-${name}`]: help,
            [`error-${name}`]: error,
          }) || undefined
        }
        aria-invalid={error}
        name={name}
        id={fieldDomId}
        value={value}
        placeholder={placeholder}
        readOnly={readOnly}
        required={required}
        onChange={(e) => onChange(name, e.target.value)}
        onFocus={onFocus}
        onBlur={() => {
          onBlur();
          validate(!!value);
        }}
        onPaste={onPaste}
      />
      <Tooltip tooltip={tooltip} labeledBy={`label-${fieldDomId}`} />
      <Help help={help} id={`help-${name}`} />
    </div>

    <ErrorMsg name={name} />
  </>
);

Number.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  error: PropTypes.bool.isRequired,
  fieldDomId: PropTypes.string.isRequired,
  help: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired,
  required: PropTypes.bool.isRequired,
  tooltip: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  validate: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

const NumberStyled = withStyles(styles)(Number);

const mapStateToProps = ({ fields }, { name }) => {
  const field = fields[name];
  return {
    type: field.mobileInputType || 'tel',
  };
};

export default withFieldProps(mapStateToProps)(NumberStyled);
